export default (urlParameters) => {
  const { platform } = urlParameters

  return {
    ads_allowed: false,
    platform: platform
  }
}
